export var SourceReorder;
(function (SourceReorder) {
    SourceReorder["FRONT"] = "front";
    SourceReorder["BACK"] = "back";
    SourceReorder["FORWARD"] = "froward";
    SourceReorder["BACKWARD"] = "backward";
})(SourceReorder || (SourceReorder = {}));
